import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SCreateFormInput = styled.div`
  margin-bottom: 16px;

  ${setFlexDFFDC};
`;
